const Component = {
  render: function render() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      'div',
      [
        _c('h1', { staticClass: 'uk-h1 tm-heading-fragment' }, [
          _vm._v('Scroll')
        ]),
        _c('p', { staticClass: 'uk-text-lead' }, [
          _vm._v(
            'Scroll smoothly when jumping to different sections on a page.'
          )
        ]),
        _vm._v(' '),
        _vm._m(0),
        _vm._m(1),
        _vm._v(' '),
        _vm._m(2),
        _c('md-code-example-90'),
        _c('hr', { staticClass: 'uk-margin-large' }),
        _vm._m(3),
        _vm._m(4),
        _vm._v(' '),
        _vm._m(5),
        _c('md-code-example-91'),
        _c(
          'p',
          [
            _c('vk-label', [_vm._v('Note')]),
            _vm._v(' '),
            _c('code', [_vm._v('target')]),
            _vm._v(' is the '),
            _c('em', [_vm._v('primary')]),
            _vm._v(
              " option and its key may be omitted if it's the only option in the directive value."
            )
          ],
          1
        ),
        _vm._v(' '),
        _c('hr', { staticClass: 'uk-margin-large' }),
        _vm._m(6),
        _vm._m(7),
        _vm._v(' '),
        _vm._m(8),
        _c('md-code-example-92'),
        _c('hr', { staticClass: 'uk-margin-large' }),
        _vm._m(9),
        _vm._m(10),
        _c(
          'p',
          [
            _c('vk-label', [_vm._v('Note')]),
            _vm._v(
              ' You can learn about directives and how to apply options at the '
            ),
            _c(
              'router-link',
              { staticClass: 'tm-internal-link', attrs: { to: 'directives' } },
              [_vm._v('Directives guide')]
            ),
            _vm._v('.')
          ],
          1
        ),
        _vm._v(' '),
        _c('hr', { staticClass: 'uk-margin-large' }),
        _vm._m(11),
        _c('p', [
          _vm._v(
            'The following events will be triggered on elements with this directive attached:'
          )
        ]),
        _vm._v(' '),
        _vm._m(12),
        _c('div', { staticStyle: { height: '2000px' } }),
        _vm._v(' '),
        _c(
          'p',
          [
            _c(
              'vk-button-link',
              {
                directives: [{ name: 'vk-scroll', rawName: 'v-vk-scroll' }],
                attrs: { type: 'primary', id: 'target', href: '#top' }
              },
              [_vm._v('Scroll up')]
            )
          ],
          1
        )
      ],
      1
    )
  },
  staticRenderFns: [
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c(
        'h2',
        { staticClass: 'uk-h2 tm-heading-fragment', attrs: { id: 'usage' } },
        [_c('a', { attrs: { href: '#usage' } }, [_vm._v('Usage')])]
      )
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('p', [
        _vm._v('Apply the '),
        _c('code', [_vm._v('v-vk-scroll')]),
        _vm._v(
          ' directive to any anchor element that contains a URL fragment to add the smooth scrolling behavior.'
        )
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('div', { staticClass: 'uk-margin-medium' }, [
        _c('pre', [
          _c('code', { staticClass: 'lang-html hljs' }, [
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('a')]),
              _vm._v(' '),
              _c('span', { staticClass: 'hljs-attr' }, [_vm._v('href')]),
              _vm._v('='),
              _c('span', { staticClass: 'hljs-string' }, [_vm._v('"#my-id"')]),
              _vm._v(' '),
              _c('span', { staticClass: 'hljs-attr' }, [_vm._v('v-vk-scroll')]),
              _vm._v('>')
            ]),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('a')]),
              _vm._v('>')
            ])
          ])
        ])
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c(
        'h2',
        {
          staticClass: 'uk-h2 tm-heading-fragment',
          attrs: { id: 'multiple-anchors' }
        },
        [
          _c('a', { attrs: { href: '#multiple-anchors' } }, [
            _vm._v('Multiple anchors')
          ])
        ]
      )
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('p', [
        _vm._v('If you apply '),
        _c('code', [_vm._v('v-vk-scroll')]),
        _vm._v(
          ' to an element other that anchor it will target all the child anchors and apply the scrolling individually. You can change the match criteria with the '
        ),
        _c('code', [_vm._v('target')]),
        _vm._v(' option.')
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('div', { staticClass: 'uk-margin-medium' }, [
        _c('pre', [
          _c('code', { staticClass: 'lang-html hljs' }, [
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('p')]),
              _vm._v(' '),
              _c('span', { staticClass: 'hljs-attr' }, [_vm._v('v-vk-scroll')]),
              _vm._v('='),
              _c('span', { staticClass: 'hljs-string' }, [
                _vm._v('"\'SELECTOR\'"')
              ]),
              _vm._v('>')
            ]),
            _vm._v('\n  '),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('a')]),
              _vm._v(' '),
              _c('span', { staticClass: 'hljs-attr' }, [_vm._v('href')]),
              _vm._v('>')
            ]),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('a')]),
              _vm._v('>')
            ]),
            _vm._v('\n  '),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('a')]),
              _vm._v(' '),
              _c('span', { staticClass: 'hljs-attr' }, [_vm._v('href')]),
              _vm._v('>')
            ]),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('a')]),
              _vm._v('>')
            ]),
            _vm._v('\n'),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('p')]),
              _vm._v('>')
            ])
          ])
        ])
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c(
        'h2',
        {
          staticClass: 'uk-h2 tm-heading-fragment',
          attrs: { id: 'callbacks' }
        },
        [_c('a', { attrs: { href: '#callbacks' } }, [_vm._v('Callbacks')])]
      )
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('p', [
        _vm._v(
          'To receive a callback when scrolling has completed, you can listen to the '
        ),
        _c('code', [_vm._v('afterScroll')]),
        _vm._v(
          ' event on the element that triggered the scrolling. As well as listen to '
        ),
        _c('code', [_vm._v('beforeScroll')]),
        _vm._v(' to do some action or prevent scrolling by returning '),
        _c('code', [_vm._v('false')]),
        _vm._v('.')
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('div', { staticClass: 'uk-margin-medium' }, [
        _c('pre', [
          _c('code', { staticClass: 'lang-html hljs' }, [
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('a')]),
              _vm._v(' '),
              _c('span', { staticClass: 'hljs-attr' }, [_vm._v('href')]),
              _vm._v('='),
              _c('span', { staticClass: 'hljs-string' }, [_vm._v('"#my-id"')]),
              _vm._v(' '),
              _c('span', { staticClass: 'hljs-attr' }, [_vm._v('v-vk-scroll')]),
              _vm._v(' @'),
              _c('span', { staticClass: 'hljs-attr' }, [
                _vm._v('beforeScroll')
              ]),
              _vm._v(' @'),
              _c('span', { staticClass: 'hljs-attr' }, [_vm._v('afterScroll')]),
              _vm._v('>')
            ]),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('a')]),
              _vm._v('>')
            ])
          ])
        ])
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c(
        'h2',
        { staticClass: 'uk-h2 tm-heading-fragment', attrs: { id: 'options' } },
        [_c('a', { attrs: { href: '#options' } }, [_vm._v('Options')])]
      )
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('div', { staticClass: 'uk-overflow-auto' }, [
        _c('table', { staticClass: 'uk-table uk-table-divider' }, [
          _c('thead', [
            _c('tr', [
              _c('th', [_vm._v('Name')]),
              _vm._v(' '),
              _c('th', [_vm._v('Type')]),
              _vm._v(' '),
              _c('th', [_vm._v('Default')]),
              _vm._v(' '),
              _c('th', [_vm._v('Description')])
            ])
          ]),
          _vm._v(' '),
          _c('tbody', [
            _c('tr', [
              _c('td', [_c('code', [_vm._v('target')])]),
              _vm._v(' '),
              _c('td', [_vm._v('String')]),
              _vm._v(' '),
              _c('td', [_c('code', [_vm._v('a')])]),
              _vm._v(' '),
              _c('td', [
                _vm._v('Selector that will be used to match child anchors.')
              ])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', [_c('code', [_vm._v('duration')])]),
              _vm._v(' '),
              _c('td', [_vm._v('Number')]),
              _vm._v(' '),
              _c('td', [_c('code', [_vm._v('1000')])]),
              _vm._v(' '),
              _c('td', [_vm._v('Animation duration in milliseconds.')])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', [_c('code', [_vm._v('offset')])]),
              _vm._v(' '),
              _c('td', [_vm._v('Number')]),
              _vm._v(' '),
              _c('td', [_c('code', [_vm._v('0')])]),
              _vm._v(' '),
              _c('td', [_vm._v('Pixel offset added to scroll top.')])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', [_c('code', [_vm._v('force')])]),
              _vm._v(' '),
              _c('td', [_vm._v('Boolean')]),
              _vm._v(' '),
              _c('td', [_c('code', [_vm._v('false')])]),
              _vm._v(' '),
              _c('td', [
                _vm._v(
                  'Forces the scrolling even if link default action has been prevented.'
                )
              ])
            ])
          ])
        ])
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c(
        'h3',
        { staticClass: 'uk-h3 tm-heading-fragment', attrs: { id: 'events' } },
        [_c('a', { attrs: { href: '#events' } }, [_vm._v('Events')])]
      )
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('div', { staticClass: 'uk-overflow-auto' }, [
        _c('table', { staticClass: 'uk-table uk-table-divider' }, [
          _c('thead', [
            _c('tr', [
              _c('th', { staticStyle: { 'text-align': 'left' } }, [
                _vm._v('Name')
              ]),
              _vm._v(' '),
              _c('th', { staticStyle: { 'text-align': 'left' } }, [
                _vm._v('Description')
              ])
            ])
          ]),
          _vm._v(' '),
          _c('tbody', [
            _c('tr', [
              _c('td', { staticStyle: { 'text-align': 'left' } }, [
                _c('code', [_vm._v('beforeScroll')])
              ]),
              _vm._v(' '),
              _c('td', { staticStyle: { 'text-align': 'left' } }, [
                _vm._v(
                  'Fires before scroll begins. Can prevent scrolling by returning '
                ),
                _c('code', [_vm._v('false')]),
                _vm._v('.')
              ])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', { staticStyle: { 'text-align': 'left' } }, [
                _c('code', [_vm._v('afterScroll')])
              ]),
              _vm._v(' '),
              _c('td', { staticStyle: { 'text-align': 'left' } }, [
                _vm._v('Fires after scrolling is finished.')
              ])
            ])
          ])
        ])
      ])
    }
  ],
  data: function() {
    return {}
  },
  scrollToTop: true,
  sections: [
    { id: 'usage', title: 'Usage' },
    { id: 'multiple-anchors', title: 'Multiple anchors' },
    { id: 'callbacks', title: 'Callbacks' },
    { id: 'options', title: 'Options' }
  ],
  components: {
    'md-code-example-90': {
      render: function render() {
        var _vm = this
        var _h = _vm.$createElement
        var _c = _vm._self._c || _h
        return _c(
          'div',
          { staticClass: 'uk-position-relative uk-margin-medium' },
          [
            _c(
              'vk-tabs',
              { staticClass: 'uk-margin' },
              [
                _c(
                  'vk-tabs-item',
                  { attrs: { title: 'Preview' } },
                  [
                    _c(
                      'vk-button-link',
                      {
                        directives: [
                          { name: 'vk-scroll', rawName: 'v-vk-scroll' }
                        ],
                        attrs: { type: 'primary', href: '#target' }
                      },
                      [_vm._v('\n  Scroll down\n')]
                    )
                  ],
                  1
                ),
                _vm._v(' '),
                _c('vk-tabs-item', { attrs: { title: 'Markup' } }, [
                  _c('pre', [
                    _c(
                      'code',
                      { staticClass: 'lang-html hljs', attrs: { id: '90' } },
                      [
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button-link')
                          ]),
                          _vm._v(' \n  '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('type')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"primary"')
                          ]),
                          _vm._v(' \n  '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('href')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"#target"')
                          ]),
                          _vm._v('\n  '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('v-vk-scroll')
                          ]),
                          _vm._v('\n>')
                        ]),
                        _vm._v('\n  Scroll down\n'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button-link')
                          ]),
                          _vm._v('>')
                        ])
                      ]
                    )
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      },
      data: function() {
        return {}
      }
    },
    'md-code-example-91': {
      render: function render() {
        var _vm = this
        var _h = _vm.$createElement
        var _c = _vm._self._c || _h
        return _c(
          'div',
          { staticClass: 'uk-position-relative uk-margin-medium' },
          [
            _c(
              'vk-tabs',
              { staticClass: 'uk-margin' },
              [
                _c('vk-tabs-item', { attrs: { title: 'Preview' } }, [
                  _c(
                    'p',
                    {
                      directives: [
                        {
                          name: 'vk-scroll',
                          rawName: 'v-vk-scroll',
                          value: 'span > a',
                          expression: "'span > a'"
                        }
                      ]
                    },
                    [
                      _c(
                        'span',
                        [
                          _c(
                            'vk-button-link',
                            { attrs: { type: 'primary', href: '#target' } },
                            [_vm._v('\n      I match!\n    ')]
                          )
                        ],
                        1
                      ),
                      _vm._v(' '),
                      _c('vk-button-link', { attrs: { href: '#target' } }, [
                        _vm._v("\n    I don't :(\n  ")
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(' '),
                _c('vk-tabs-item', { attrs: { title: 'Markup' } }, [
                  _c('pre', [
                    _c(
                      'code',
                      { staticClass: 'lang-html hljs', attrs: { id: '91' } },
                      [
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('p')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('v-vk-scroll')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"\'span > a\'"')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n  '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('span')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n    '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button-link')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('type')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"primary"')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('href')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"#target"')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n      I match!\n    '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button-link')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n  '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('span')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n  '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button-link')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('href')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"#target"')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v("\n    I don't :(\n  "),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button-link')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('p')
                          ]),
                          _vm._v('>')
                        ])
                      ]
                    )
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      },
      data: function() {
        return {}
      }
    },
    'md-code-example-92': {
      render: function render() {
        var _vm = this
        var _h = _vm.$createElement
        var _c = _vm._self._c || _h
        return _c(
          'div',
          { staticClass: 'uk-position-relative uk-margin-medium' },
          [
            _c(
              'vk-tabs',
              { staticClass: 'uk-margin' },
              [
                _c(
                  'vk-tabs-item',
                  { attrs: { title: 'Preview' } },
                  [
                    _c(
                      'vk-button-link',
                      {
                        directives: [
                          { name: 'vk-scroll', rawName: 'v-vk-scroll' }
                        ],
                        attrs: { type: 'primary', href: '#target' },
                        on: {
                          afterScroll: function($event) {
                            _vm.text = 'I did it!'
                          }
                        }
                      },
                      [_vm._v('\n  ' + _vm._s(_vm.text) + '\n')]
                    )
                  ],
                  1
                ),
                _vm._v(' '),
                _c('vk-tabs-item', { attrs: { title: 'Markup' } }, [
                  _c('pre', [
                    _c(
                      'code',
                      { staticClass: 'lang-html hljs', attrs: { id: '92' } },
                      [
                        _vm._v("---\ntext: 'Down with callback'\n---\n\n"),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button-link')
                          ]),
                          _vm._v('\n  '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('type')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"primary"')
                          ]),
                          _vm._v('\n  '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('href')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"#target"')
                          ]),
                          _vm._v('\n  '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('v-vk-scroll')
                          ]),
                          _vm._v('\n  @'),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('afterScroll')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"text = \'I did it!\'"')
                          ]),
                          _vm._v('\n>')
                        ]),
                        _vm._v('\n  '),
                        _c('span', [_vm._v('{{')]),
                        _vm._v(' text '),
                        _c('span', [_vm._v('}}')]),
                        _vm._v('\n'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button-link')
                          ]),
                          _vm._v('>')
                        ])
                      ]
                    )
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      },
      data: function() {
        return { text: 'Down with callback' }
      }
    }
  }
}


export default Component
